import * as AWS from "aws-sdk";

// Configuração do cliente S3
const s3 = new AWS.S3({
  region: process.env.REACT_APP_AWS_REGION, // Usando a variável de ambiente
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID, // Usando a variável de ambiente
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY // Usando a variável de ambiente
});

const uploadFileToS3 = async (file, key, cnpj, onProgress) => {
  let cnpjLimpo = cnpj?.replace(/\D/g, ""); // Remove tudo que não for número

  if (!file) {
    throw new Error("Nenhum arquivo fornecido.");
  }

  // Verificação do tipo de arquivo e tamanho
  if (file.size > 50 * 1024 * 1024) {
    // Limite de 50MB
    throw new Error("O arquivo excede o tamanho máximo permitido.");
  }

  const params = {
    Bucket: "medusapayments-documentos-empresas",
    Key: `${cnpjLimpo}/${key}-${Date.now()}-${file.name}`, // Caminho e nome do arquivo com timestamp
    Body: file, // O arquivo a ser enviado
    ContentType: file.type // Tipo de conteúdo do arquivo
  };

  try {
    const upload = s3.upload(params);

    // Adicionando o listener de progresso
    upload.on("httpUploadProgress", (progress) => {
      if (progress.total) {
        const percentage = Math.round((progress.loaded / progress.total) * 100);
        onProgress(percentage); // Atualiza a barra de progresso
      }
    });

    // Espera o upload ser completado
    const uploadResult = await upload.promise();
    return uploadResult.Location; // Retorna o URL do arquivo enviado
  } catch (error) {
    throw error;
  }
};

export { uploadFileToS3 };
